export const SET_ELIGIBILITY_VALUES = 'DRSA/ELIGIBILITY/SET_ELIGIBILITY_VALUES';
export const CLEAR_OTP = 'DRSA/ELIGIBILITY/CLEAR_OTP';
export const RESEND_SMS = 'DRSA/ELIGIBILITY/RESEND_SMS';

const initialState = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  plateNumber: '',
  phoneCountry: '',
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ELIGIBILITY_VALUES:
      return { ...state, ...action.payload };
    case CLEAR_OTP:
      return { ...state, otp: undefined };
    default:
      return state;
  }
};

export const storeData = ({ payload }) => ({ type: SET_ELIGIBILITY_VALUES, payload });

export const clearOTP = () => ({ type: CLEAR_OTP });
export const resendSMS = () => ({ type: RESEND_SMS });

const actions = {
  storeData,
  clearOTP,
  resendSMS,
};

export default { reducer, actions };
